import React from 'react';
import ReactDOM from 'react-dom/client';
import { Route, Routes, BrowserRouter } from 'react-router-dom';

import Contact from './Components/Contact/Contact';
import Home from './Components/Home/Home';
import Navbar from "./Components/Navbar/Navbar";
import Notfound from "./Components/Notfound/Notfound";
import Education from './Components/Education/Education';
import Myprojects from './Components/Myprojects/Myprojects';
import Skills from './Components/Skills/Skills';

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import '@fortawesome/fontawesome-free/css/all.min.css'
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Navbar />
      <div className="container">
        <Routes>
          <Route path='/' element={<Home />}></Route>
          <Route path='home' element={<Home />}></Route>
          <Route path='contact' element={<Contact />}></Route>
          <Route path='skills' element={<Skills />}></Route>
          <Route path='myprojects' element={<Myprojects />}></Route>
          <Route path='education' element={<Education />}></Route>
          <Route path='*' element={<Notfound />}></Route>
        </Routes>
      </div>
    </BrowserRouter>
  </React.StrictMode>
);

